export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Info Google Business',
    google_reviews: 'Recensioni Google',
    settings: 'Impostazioni',
    danger_zone: 'Zona pericolosa',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Risposte automatiche AI',
    },
    reviews_autopilot_daily_limit: {
      label: 'Limite giornaliero risposte automatiche AI (min 1, max 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Ore da attendere dopo la scrittura di una recensione',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Mostra tutte le recensioni',
      show_only_unanswered: 'Mostra solo quelle senza risposta',
    },
    rating_filter: {
      label: 'Filtro valutazione',
      stars_one: '{{count}} stella',
      stars_other: '{{count}} stelle',
    },
    sorting: {
      newest_to_oldest: 'Ordina dalla più recente alla più vecchia',
      oldest_to_newest: 'Ordina dalla più vecchia alla più recente',
      rating_highest_to_lowest: 'Ordina dalla valutazione più alta alla più bassa',
      rating_lowest_to_highest: 'Ordina dalla valutazione più bassa alla più alta',
    },
  },
  table: {
    pagination: {
      total_one: 'Totale {{count}} recensione',
      total_other: 'Totale {{count}} recensioni',
    },
  },
  modal_publish: {
    title: 'Sei sicuro di voler pubblicare su Google?',
    buttons: {
      yes: 'Sì',
      cancel: 'Annulla',
    },
  },
  popconfirm: {
    title: 'Sei sicuro?',
    description: 'Tutte le modifiche locali verranno sovrascritte',
  },
  disconnect_profile: {
    title: 'Disconnetti profilo',
    button: 'Procedi',
    popconfirm: {
      title: 'Sei sicuro?',
      description:
        'Questa operazione disconnetterà completamente questo profilo Google dal sistema FoodAmigos, inclusa la sostituzione automatica dei link e il pilota automatico delle risposte alle recensioni!',
    },
  },
  buttons: {
    login_with_google: 'Accedi con Google',
    sync_from_google: 'Ottieni versione aggiornata',
    publish_to_google: 'Pubblica su Google',
    previous: 'Precedente',
    next: 'Successivo',
    save_settings: 'Salva impostazioni',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
    failed_to_fetch_reviews: 'Recupero delle recensioni non riuscito',
    failed_to_fetch_settings: 'Recupero delle impostazioni non riuscito',
    failed_to_load_google_business: 'Caricamento di Google Business non riuscito',
    failed_to_publish_to_google_business: 'Pubblicazione su Google Business non riuscita',
    publish_access_denied:
      "Google ha rifiutato l'aggiornamento: l'account Google collegato non può più modificare questo profilo dell'attività. Controlla l'accesso in Google Business Profile o ricollega l'account che gestisce il ristorante.",
    failed_to_fetch_info: 'Recupero della versione aggiornata di Google Business non riuscito',
    success_publish_to_google_business: 'Pubblicazione su Google Business completata',
    success_sync_from_google: 'Sincronizzazione da Google Business completata',
    success_save_settings: 'Impostazioni salvate correttamente',
    failed_to_disconnect_profile: 'Disconnessione di Google Business non riuscita, contatta il team tecnico!',
    popup_blocked: 'Consenti i pop-up per questo sito per collegare Google Business.',
    failed_to_connect: 'Impossibile collegare Google Business. Riprova.',
    no_business_profile:
      "Questo account Google non gestisce alcun profilo dell'attività. Accedi con l'account Google che gestisce il ristorante.",
  },
  callback: {
    connecting: 'Collegamento di Google Business in corso…',
    connected: 'Google Business è collegato. Puoi chiudere questa finestra.',
    cancelled: "L'accesso è stato annullato. Puoi chiudere questa finestra.",
    failed: 'Impossibile collegare Google Business. Chiudi questa finestra e riprova.',
  },
  alerts: {
    no_profile: {
      title: 'Nessun luogo Google collegato',
      description: 'Collega il ristorante a un luogo Google.',
      button: {
        connect: 'Collega',
      },
    },
    unverified_location: {
      title: 'Google Business non è verificato',
      description: 'Verifica il tuo Google Business per procedere',
    },
  },
};
